import React from 'react'
import {useHistory} from 'react-router-dom'
import AuthLayout from './layout'
import { useTranslation } from 'react-i18next'
import {EAlert} from "../../enums";
import {AlertBig} from "../../components/alert/AlertBig";
import {ButtonPrimary} from "../../components/button";

export const EmailVerifyError = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onContinue = (e) => {
    history.push("/auth/signin");
  }

  return (
     <AuthLayout imgUrl="/pages/auth/illustration.svg"
                 title={t('auth.email_verification.title')}
                 >
       <div className="w-full mb-6">
         <AlertBig
           type={EAlert.error}
           title={t('auth.email_verification.error')}
         ></AlertBig>

         <ButtonPrimary
           className={'w-full mt-6'}
           onClick={onContinue}
         >
           {t('auth.email_verification.complete_button')}
         </ButtonPrimary>
       </div>
     </AuthLayout>
  )
}

export const EmailVerifyCompleted = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const onContinue = (e) => {
    history.push("/auth/signin");
  }

  return (
      <AuthLayout imgUrl="/pages/auth/illustration.svg"
                  title={t('auth.email_verification.title')}
      >
        <div className="w-full mb-6">
          <AlertBig
            type={EAlert.success}
            title={t('auth.email_verification.completed')}
          ></AlertBig>

          <ButtonPrimary
            className={'w-full mt-6'}
            onClick={onContinue}
          >
            {t('auth.email_verification.complete_button')}
          </ButtonPrimary>
        </div>
      </AuthLayout>
  )
}
